"use client";
import { useEffect, useState } from "react";

export function PWALoader({ children }) {
	const [isPWA, setIsPWA] = useState(false);

	useEffect(() => {
		// Detectează dacă aplicația rulează în mod standalone (PWA)
		const isStandalone =
			window.matchMedia("(display-mode: standalone)").matches ||
			window.navigator.standalone === true ||
			document.referrer.includes("android-app://");

		setIsPWA(isStandalone);
	}, []);

	if (!isPWA) {
		return <>{children}</>;
	}

	return <PWALoaderWrapper>{children}</PWALoaderWrapper>;
}

function PWALoaderWrapper({ children }) {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Simulează încărcarea inițială
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	if (isLoading) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: "#ffffff",
					zIndex: 9999,
				}}>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: "20px",
					}}>
					{/* Spinner animat */}
					<div
						style={{
							width: "50px",
							height: "50px",
							border: "4px solid #f3f3f3",
							borderTop: "4px solid #fd7e14",
							borderRadius: "50%",
							animation: "spin 1s linear infinite",
						}}
					/>
					<p
						style={{
							fontSize: "16px",
							color: "#666",
							margin: 0,
						}}>
			
					</p>
				</div>
				<style jsx>{`
					@keyframes spin {
						0% {
							transform: rotate(0deg);
						}
						100% {
							transform: rotate(360deg);
						}
					}
				`}</style>
			</div>
		);
	}

	return <>{children}</>;
}
